import { FC } from "react";

import { Text } from "atoms/Text/Text";
import { useUser } from "modules/user/useUser/useUser";

import { replacePersonaPlaceholders } from "../adonis.helpers";
import { useAdonisChat } from "../AdonisChatProvider/AdonisChatProvider";
import adonisHeaderBg from "../assets/adonis_header_bg.webp";
import ariaHeaderBg from "../assets/aria_header_bg.webp";

interface AdvisorShopCategoryHeaderText {
  title: string;
  subtitle: string;
}

export interface AdvisorShopCategoryHeaderProps {
  headerText?: AdvisorShopCategoryHeaderText;
  className?: string;
}

const VARIANT_BACKGROUNDS: Record<string, string> = {
  Adonis: adonisHeaderBg,
  Aria: ariaHeaderBg,
};

export const AdvisorShopCategoryHeader: FC<AdvisorShopCategoryHeaderProps> = ({
  headerText,
  className = "",
}) => {
  const { persona } = useAdonisChat();
  const { user } = useUser();

  const username = user?.firstName ?? "";

  const defaultText: AdvisorShopCategoryHeaderText = {
    title: "Just for you, {username}",
    subtitle: "Curated for you by {Name} AI",
  };

  const mergedText: AdvisorShopCategoryHeaderText = {
    title: headerText?.title ?? defaultText.title,
    subtitle: headerText?.subtitle ?? defaultText.subtitle,
  };

  const text: AdvisorShopCategoryHeaderText = {
    title: replacePersonaPlaceholders(
      mergedText.title.replace("{username}", username),
      persona
    ),
    subtitle: replacePersonaPlaceholders(mergedText.subtitle, persona),
  };

  const backgroundImage = VARIANT_BACKGROUNDS[persona.name] || adonisHeaderBg;

  return (
    <div
      className={`flex h-[200px] w-full items-center overflow-hidden px-6 ${className}`}
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="flex w-3/5 flex-col">
        <Text
          component="h1"
          className="mb-1 font-serif text-h1 font-medium text-primary"
        >
          {text.title}
        </Text>
        <Text component="p" className="text-body2">
          {text.subtitle}
        </Text>
      </div>
    </div>
  );
};
